module.exports = __webpack_public_path__ + "static/img/11.c42ee08.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/5/sp/11.png
// module id = 1OjW
// module chunks = 0